// frontend/src/pages/admin/BlogListPage.jsx
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Edit, Trash2, Loader2, Eye } from 'lucide-react';
import { PageSEO } from '../../components/SEO/PageSEO';
import api from '../../services/api';
import config from '../../config';

export const BlogListPage = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    try {
      const response = await api.get('/cms/blog/');
      setPosts(response.data.results || response.data || []);
    } catch (error) {
      console.error('Error fetching posts:', error);
    } finally {
      setLoading(false);
    }
  };

  const deletePost = async (slug) => {
    if (window.confirm('آیا از حذف این مقاله اطمینان دارید؟')) {
      try {
        const accessToken = localStorage.getItem('access_token');
        await fetch(config.getApiUrl(`/cms/blog/${slug}/`), {
          method: 'DELETE',
          headers: { 'Authorization': `Bearer ${accessToken}` }
        });
        fetchPosts();
        alert('مقاله با موفقیت حذف شد');
      } catch (error) {
        console.error('Error deleting post:', error);
        alert('خطا در حذف مقاله');
      }
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <Loader2 className="w-10 h-10 animate-spin text-blue-600" />
      </div>
    );
  }

  return (
    <>
      <PageSEO title="مدیریت مقالات | پنل ادمین"
        description="مدیریت مقالات وبلاگ"
        noindex={true} />
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center mb-8">
            <h1 className="text-2xl font-bold text-gray-900">مدیریت مقالات</h1>
            <Link
              to="/admin/blog/new"
              className="bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-blue-700"
            >
              <Plus className="w-5 h-5" />
              افزودن مقاله جدید
            </Link>
          </div>

          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">تصویر</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">عنوان</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">نویسنده</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">تاریخ</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">بازدید</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">عملیات</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {posts.map((post) => (
                  <tr key={post.id}>
                    <td className="px-6 py-4">
                      <img
                        src={post.featured_image || '/placeholder-image.jpg'}
                        alt=""
                        className="w-10 h-10 rounded object-cover"
                      />
                    </td>
                    <td className="px-6 py-4 font-medium max-w-xs truncate">{post.title}</td>
                    <td className="px-6 py-4">{post.author?.username || 'مدیر'}</td>
                    <td className="px-6 py-4">{new Date(post.published_at).toLocaleDateString('fa-IR')}</td>
                    <td className="px-6 py-4">{post.view_count || 0}</td>
                    <td className="px-6 py-4">
                      <div className="flex gap-2">
                        <Link to={`/blog/${post.slug}`} target="_blank" className="text-green-600 hover:text-green-800">
                          <Eye className="w-5 h-5" />
                        </Link>
                        <Link to={`/admin/blog/${post.slug}/edit`} className="text-blue-600 hover:text-blue-800">
                          <Edit className="w-5 h-5" />
                        </Link>
                        <button onClick={() => deletePost(post.slug)} className="text-red-600 hover:text-red-800">
                          <Trash2 className="w-5 h-5" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
